
export const GET_EMPTY_REQUEST = 'GET_EMPTY_REQUEST'
export const GET_EMPTY_SUCCESS = 'GET_EMPTY_SUCCESS'
export const GET_EMPTY_FAILURE = 'GET_EMPTY_FAILURE'

export const GET_CONTAINER_REQUEST = 'GET_CONTAINER_REQUEST'
export const GET_CONTAINER_SUCCESS = 'GET_CONTAINER_SUCCESS'
export const GET_CONTAINER_FAILURE = 'GET_CONTAINER_FAILURE'

export const GET_MULTIPLE_CONTAINERS_REQUEST = 'GET_MULTIPLE_CONTAINERS_REQUEST'
export const GET_MULTIPLE_CONTAINERS_SUCCESS = 'GET_MULTIPLE_CONTAINERS_SUCCESS'
export const GET_MULTIPLE_CONTAINERS_FAILURE = 'GET_MULTIPLE_CONTAINERS_FAILURE'
export const SET_EMPTY_PLANT_CONTAINER = 'SET_EMPTY_PLANT_CONTAINER'
export const SET_EMPTY_PLANT_CONTAINERS = 'SET_EMPTY_PLANT_CONTAINERS'
